import useAppSelector from "@/core/helpers/useAppSelector";
import { playerInfoSelector } from "@/domains/player/slice";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";

export default function PlayerMenuCharacterProgressCardContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);

  if (!playerInfo?.character) return null;

  return (
    <PlayerMenuCharacterDataCard
      style={{
        backgroundImage:
          "linear-gradient(229deg, rgba(205, 23, 23, 0.10) 0%, rgba(22, 22, 22, 0.10) 46.48%)",
      }}
    >
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col items-center">
          <div className="w-full relative flex items-center gap-3.5 overflow-clip">
            <div className="relative flex items-center justify-center w-[3.25rem] aspect-square shrink-0">
              <img src="./svg/player-menu/circle.svg" alt="" className="absolute w-full h-full" />
              <div className="text-20 font-bold z-1">{playerInfo.player.level}</div>
            </div>
            <div>
              <div className="text-13 font-bold text-accent-solid uppercase">УРОВЕНЬ</div>
              <div className="text-12 font-bold uppercase">ТЕКУЩИЙ</div>
            </div>
            <img
              src="./svg/inventory/character.svg"
              alt=""
              className="absolute -top-2.5 -right-7 w-[8rem]"
              style={{
                WebkitMaskImage: "linear-gradient(to bottom, black, transparent)",
              }}
            />
          </div>
          <div className="mt-3.5 h-3.5 w-[16.375rem] flex items-center bg-gradient-to-r from-[#AB2929]/10 to-accent-solid/10 rounded-[1rem]">
            <div className="absolute h-1 w-[15.9375rem] bg-gradient-to-r from-[#AB2929]/40 to-accent-solid/40 rounded-[1rem]" />
            <div
              className="absolute h-1.5 w-[15.9375rem] bg-gradient-to-r from-[#AB2929] to-accent-solid rounded-[1rem]"
              style={{
                clipPath: `polygon(0% 0%, ${50}% 0%, ${50}% 100%, 0% 100%)`,
              }}
            />
          </div>
          <div className="w-full flex items-center justify-between mt-3">
            <div className="text-10 text-white/50 font-bold uppercase">ОПЫТ ДО СЛЕД.УРОВНЯ:</div>
            <div className="text-14 font-bold">
              <span className="text-accent-solid">1000</span> / 2000 XP
            </div>
          </div>
        </div>
        <div className="mt-auto text-18 font-bold">Прогресс персонажа</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
